import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import setMailboxOperation from 'owa-service/lib/operation/setMailboxOperation';
import OptionsResponseBase from 'owa-service/lib/contract/OptionsResponseBase';
import MailboxOptions from 'owa-service/lib/contract/MailboxOptions';

export default function setMailboxForwardingConfiguration(
    mailboxOptions: MailboxOptions
): Promise<OptionsResponseBase> {
    return setMailboxOperation({
        Header: getJsonRequestHeader(),
        Mailbox: mailboxOptions,
    }).then((responseMessage: OptionsResponseBase) => {
        if (responseMessage.WasSuccessful) {
            return responseMessage;
        } else {
            throw new Error(
                `setMailboxForwardingConfiguration ${responseMessage.ErrorCode} ${
                    responseMessage.ErrorMessage
                }`
            );
        }
    });
}
